import { Portal } from "client/Components";
import { userConfiguration } from "client_legacy/ndaw/workspaceAbilitiesStatusProvider";
import {
	PropsWithChildren,
	ReactElement,
	useMemo
} from "react";
import { WorkspaceLogo } from "../Layout/TitleBar/WorkspaceLogo";
import styles from "./WelcomeScreen.module.less";
import { setTrackingId } from "client/Misc/utils";

export type WelcomeScreenProps = {
	trackingId: string;
};

export const WelcomeScreen = (props: PropsWithChildren<WelcomeScreenProps>): ReactElement => {
	const {
		trackingId,
		children
	} = props;

	return (
		<Portal container={document.body}>
			<div
				{...setTrackingId(trackingId)}
				className={styles.root}
			>
				<Header />
				<div className={styles.body}>
					{children}
				</div>
			</div>
		</Portal>
	);
};
WelcomeScreen.displayName = "WelcomeWizardScreen";

const Header = (): ReactElement => {
	const productName: string = useMemo(
		() => userConfiguration().branding
			.productName,
		[]
	);

	return (
		<div className={styles.header}>
			<div className={styles.logo}>
				<WorkspaceLogo />
			</div>
			<div className={styles.logoDivider} />
			<h2
				className={styles.title}
				title={productName}
			>
				{productName}
			</h2>
		</div>
	);
};
Header.displayName = "Header";